import { render } from "./BoutiqueView.vue?vue&type=template&id=0bcad020"
import script from "./BoutiqueView.vue?vue&type=script&lang=js"
export * from "./BoutiqueView.vue?vue&type=script&lang=js"

import "./BoutiqueView.vue?vue&type=style&index=0&id=0bcad020&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__